import { t } from '@lingui/core/macro';
import { Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function DownloadPdfItem(props) {
    const { disabled, download, onDownload } = props;
    const handleDownload = () => {
        download();
        onDownload();
    };
    return (<Menu.Item disabled={disabled} onClick={handleDownload}>
      <Falcon icon="file-pdf"/>
      <Menu.ItemText primary={t({ message: 'Download PDF', comment: 'Download PDF label' })}/>
    </Menu.Item>);
}
